<main id="page">
  <router-outlet />
</main>
<app-footer />
